<template>
  <ins v-bind="$attrs"></ins>
</template>

<script>
export default {
  name: "AdsenseUnit",
  mounted() {
    console.info("load adunit");
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
};
</script>
